import { render, staticRenderFns } from "./data-table-orders.vue?vue&type=template&id=26316020&scoped=true&"
import script from "./data-table-orders.vue?vue&type=script&lang=js&"
export * from "./data-table-orders.vue?vue&type=script&lang=js&"
import style0 from "./data-table-orders.vue?vue&type=style&index=0&id=26316020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26316020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26316020')) {
      api.createRecord('26316020', component.options)
    } else {
      api.reload('26316020', component.options)
    }
    module.hot.accept("./data-table-orders.vue?vue&type=template&id=26316020&scoped=true&", function () {
      api.rerender('26316020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/sidesheet-additions/data-table-orders.vue"
export default component.exports